// extracted by mini-css-extract-plugin
export default {"IQPill":"IQPill_IQPill__ptdEE","alias":"IQPill_alias__sEtg9","iq":"IQPill_iq__Gi+Ev","compact":"IQPill_compact__4gZ+U"};